import React, { useMemo } from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { enUS as materialEnUS, zhTW as materialZhTW } from "@mui/material/locale";
import { enUS as dataGridEnUS, zhTW as dataGridZhTW } from "@mui/x-data-grid/locales";
import { useI18n } from "i18n";

const baseThemeOptions = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      light: "#6200EE",
      main: "#3700B3",
      dark: "#3700B3",
      contrastText: "#fff",
    },
    secondary: {
      light: "#FF80AB",
      main: "#FF4081",
      dark: "#F50057",
      contrastText: "#fff",
    },
  },
};

const AppThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const { locale } = useI18n();

  const theme = useMemo(() => {
    const materialLocale = locale === "zh-TW" ? materialZhTW : materialEnUS;
    const dataGridLocale = locale === "zh-TW" ? dataGridZhTW : dataGridEnUS;

    return createTheme(baseThemeOptions, materialLocale, dataGridLocale);
  }, [locale]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export { AppThemeProvider };

